import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import AulaUserContext, { aulaAuthHeaders } from '../aulaUserContext';

const Catalogo = () => {
    const { aulaAuth } = useContext(AulaUserContext);
    const [cursos, setCursos] = useState([]);
    const [misInscripciones, setMisInscripciones] = useState([]);

    useEffect(() => {
        fetch('/aula/cursos', { headers: aulaAuthHeaders() })
            .then((res) => res.json())
            .then(setCursos)
            .catch(() => setCursos([]));

        if (aulaAuth.token) {
            fetch('/aula/inscripciones/mias', { headers: aulaAuthHeaders() })
                .then((res) => res.json())
                .then(setMisInscripciones)
                .catch(() => setMisInscripciones([]));
        }
    }, [aulaAuth.token]);

    const misCursosActivos = misInscripciones.filter((i) => i.estado === 'Activo' && i.vigente && i.progreso);

    return (
        <div className="container">
            {misCursosActivos.length > 0 &&
                <>
                    <h3 className="title mb-3">Mis cursos</h3>
                    <div className="row mb-4">
                        {misCursosActivos.map((i) => (
                            <div className="col-md-6 mb-4" key={i.id}>
                                <div className="card aula-card h-100">
                                    {i.curso.imagenUrl &&
                                        <img src={i.curso.imagenUrl} alt={i.curso.nombre} className="aula-curso-caratula" />}
                                    <div className="p-3">
                                        <h5>{i.curso.nombre}</h5>
                                        <div className="progress mb-2" style={{ height: '20px' }}>
                                            <div className="progress-bar aula-progress-bar" style={{ width: `${i.progreso.porcentaje}%` }}>
                                                {i.progreso.porcentaje}%
                                            </div>
                                        </div>
                                        <p>{i.progreso.completo ? 'Completado ✓' : `${i.progreso.completados} de ${i.progreso.total} módulos`}</p>
                                        <Link className="btn aula-btn-primary" to={`/aula/curso/${i.cursoId}`}>
                                            {i.progreso.completo ? 'Ver certificado' : 'Continuar'}
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </>}

            <h3 className="title mb-4">Cursos disponibles</h3>

            <div className="row">
                {cursos.map((curso) => (
                    <div className="col-md-6 mb-4" key={curso.id}>
                        <div className="card aula-card h-100">
                            {curso.imagenUrl &&
                                <img src={curso.imagenUrl} alt={curso.nombre} className="aula-curso-caratula" />}
                            <div className="p-4 d-flex flex-column h-100">
                                <h4>{curso.nombre}</h4>
                                <p>{curso.descripcion}</p>
                                <p className="h5"><strong>${curso.precio}</strong></p>
                                <Link className="btn aula-btn-primary mt-auto align-self-start" to={`/aula/curso/${curso.id}`}>
                                    Ver curso
                                </Link>
                            </div>
                        </div>
                    </div>
                ))}
                {cursos.length === 0 && <p>Todavía no hay cursos publicados.</p>}
            </div>
        </div>
    );
};

export default Catalogo;
